import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "components/FormikControl/FormikControl";
import { Button, Grid, Paper } from "@material-ui/core";
import PropTypes from "prop-types";
import { breakDownModules, buildUpModules, fetchDataFromApi } from "utils";
import useStyles from "assets/jss/material-dashboard-react/views/roleFormStyle";
import SaveIcon from "@material-ui/icons/Save";
import ClearIcon from "@material-ui/icons/Clear";
import eightAxios, { BASE_URL } from "configs/axiosConfig";
import CheckboxTree from "react-checkbox-tree";
import "assets/css/tree.css";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import { ROLES_URL, STORAGE_CONSTANT, URLS } from "configs/constants";
import { useHistory, useParams } from "react-router-dom";
import LoadingIcon from "components/LoadingIcon/LoadingIcon";

import { useTranslation } from "react-i18next";
import { buildCssTree } from "./treeData";
import ReactSelect from "react-select/async";
import { ROLEMAPPING_FETCH_URL } from "configs/constants";
import { useNotifyContext } from "components/Notify";

const RoleForm = () => {
  const classes = useStyles();
  const history = useHistory();
  const params = useParams();
  const { t } = useTranslation();
  const [roleToEdit, setRoleToEdit] = useState(null);
  const [modules, setModules] = useState(['Banners__view']);
  const [expanded, setExpanded] = useState(["Configuration"]);
  const [cssTree, setCssTree] = useState([]);


  if (params.id) {
    useEffect(() => {
      fetchDataFromApi(`${ROLES_URL}${params.id}/`, setRoleToEdit);
    }, []);
  }

  const initialValues = roleToEdit
    ? roleToEdit
    : {
        is_active: true,
        mobile_access: true,
        name: "",
        description: "",
        role_mapping_id: "",
      };

  const [isActive, setIsActive] = useState(initialValues.is_active);

  useEffect(() => {
    eightAxios
      .get(BASE_URL + "configuration/modules/")
      .then((res) => {
        let data = buildCssTree(res.data.modules, res.data.pages);

        setCssTree(data);
      })
      .catch((err) => {
        console.error(err);
        setCssTree([]);
      });
  }, []);

   
  useEffect(() => {
    if (roleToEdit) {
      if (!modules.length) {
        setModules(breakDownModules(roleToEdit.modules_json));
      }
    }
  }, [roleToEdit]);

  const handleChecked = (checked) => {
    setModules(
      checked.filter((item) => {
        return !item.startsWith("__");
      })
    );
  };

  const handleSubmit = (values, { setSubmitting }) => {
    
    values["modules_json"] = buildUpModules(modules);
    if (values.id === undefined) {
      eightAxios
        .post(ROLES_URL, values)
        .then((res) => {
          setSubmitting(false);
          if (
            localStorage.getItem(STORAGE_CONSTANT.ROLES).includes(res.data.name)
          ) {
            localStorage.setItem(
              STORAGE_CONSTANT.NEW_MODULES,
              JSON.stringify(res.data.modules_json)
            );
          }
          history.push(URLS.ROLE_LIST);
        })
        .catch(() => {
          setSubmitting(false);
          history.push(URLS.ROLE_LIST);
        });
    } else {
      eightAxios
        .put(`${ROLES_URL}${params.id}/`, values)
        .then((res) => {
          setSubmitting(false);
          // if (
          //   localStorage.getItem(STORAGE_CONSTANT.ROLES).includes(res.data.name)
          // ) {
          //   localStorage.setItem(
          //     STORAGE_CONSTANT.NEW_MODULES,
          //     JSON.stringify(res.data.modules_json)
          //   );
          // }
          history.push(URLS.ROLE_LIST);
        })
        .catch(() => {
          setSubmitting(false);
          history.push(URLS.ROLE_LIST);
        });
    }
  };

  const validationSchema = Yup.object({
    name: Yup.string().required("Role Name Required"),
  });

  // eslint-disable-next-line no-unused-vars
  const onSwitchChanged = () => {
    setIsActive(!isActive);
  };

  if (params.id && !roleToEdit) {
    return <LoadingIcon text="Loading" image />;
  }

  return (
    <Formik
    initialValues={initialValues}
    onSubmit={handleSubmit}
    validationSchema={validationSchema}
    enableReinitialize
  >
      {() => {
        return (
          <>
            <Paper className={classes.topBanner}>
            {t("Role:")} {params.id ? t("Edit") : t("Create")}
            </Paper>
            <Paper className={classes.filterPaper} variant="outlined">
              <Form style={{ width: "100%" }}>
                <Grid
                  container
                  spacing={1}
                  alignContent="center"
                  justify="space-between"
                >
                  <Grid item xs={6} sm={6} md={2} lg={2}>
                    <FormikControl
                      name="is_active"
                      control="switch"
                      label="Is Active?"
                      color="primary"
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2}>
                    <FormikControl
                      name="mobile_access"
                      control="switch"
                      label="Mobile Access?"
                      color="primary"
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={8} lg={8}>
                    <FormikControl
                      control="input"
                      variant="outlined"
                      name="name"
                      size="small"
                      label="Role Name"
                      inputProps={{ maxLength: 100 }}
                      disabledText={["Supervisor", "Worker"]}
                      required
                    />
                  </Grid>
                </Grid>
                <FormikControl
                  control="input"
                  variant="outlined"
                  name="description"
                  fullWidth
                  multiline
                  rows={3}
                  size="medium"
                  label="Description"
                />
                <Grid item container direction="column">
                  <Paper className={classes.topBanner}>
                    {t("Task Action")}
                  </Paper>
                  <div className={classes.treeContainer}>
                    <CheckboxTree
                      checkModel="all"
                      nodes={cssTree}
                      checked={modules}
                      expanded={expanded}
                      onCheck={(checked) => handleChecked(checked)}
                      onExpand={(expanded) => setExpanded(expanded)}
                    />
                  </div>
                </Grid>
                <br/>
                <FormikControl
                  control="reactselect"
                  variant="outlined"
                  name="role_mapping"
                  fullWidth
                  multiline
                  isMultiSelect
                  paginated={true}
                  size="medium"
                  label="Role Mapping"
                  proxyUrl={ROLEMAPPING_FETCH_URL}
                  
                />
                <Grid
                  container
                  direction="row"
                  className={classes.buttonContainer}
                >
                  <Button
                    type="submit"
                    startIcon={<SaveIcon />}
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                  >
                    {t("Submit")}
                  </Button>
                  <Button
                    startIcon={<ClearIcon />}
                    variant="contained"
                    color="secondary"
                    className={classes.cancel}
                    onClick={() => history.push(URLS.ROLE_LIST)}
                  >
                    {t("Cancel")}
                  </Button>
                </Grid>
              </Form>
            </Paper>
          </>
        );
      }}
    </Formik>
  );
};

RoleForm.propTypes = {
  data: PropTypes.object,
  switchToList: PropTypes.func,
};

export default RoleForm;
